export function Cluster() {
    this.nodes = {};
    this.width = 0;
    this.maxCliqueSize = 1;
}